import { render, staticRenderFns } from "./CursosCurricula.vue?vue&type=template&id=0f9620c8&scoped=true&"
import script from "./CursosCurricula.vue?vue&type=script&lang=js&"
export * from "./CursosCurricula.vue?vue&type=script&lang=js&"
import style0 from "./CursosCurricula.vue?vue&type=style&index=0&id=0f9620c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9620c8",
  null
  
)

export default component.exports